export const DEMO_SUBID = '999'
export const DEMO_DATASET_ID = '123'
export const DEMO_BASE = '/maptac/demo'
export const DEMO_PROGRESS_MS = 10000
export const DEMO_RESULTS_READY_KEY = 'demoResultsReady'
